export default "https://cdn-static.gokick.com/assets/29e4076df1e4180397d7539366c975103b08717a/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";